import api from 'infra/config/api';

export default function getPeerReviewService(bookId) {
    const url = `/get-peer-review.php?book_id=${bookId}`
    return api
    .url(url)
    .get()
    .json();
}